import React, { Component } from 'react';
import Modal from 'react-modal';
import WorkConfidenceForm from '../WorkConfidenceForm/WorkConfidenceForm';
import WorkConfidenceThankYou from '../WorkConfidenceThankYou/WorkConfidenceThankYou';
import WorkConfidenceAlreadyDownloaded from '../WorkConfidenceAlreadyDownloaded/WorkConfidenceAlreadyDownloaded';
import {sendSurveyForm} from '../../utils/api';
import { downloadPDF } from '../../utils/downloadpdf';
import { strict } from 'assert';

class WorkConfidenceButton extends Component {

    constructor(props){
        super(props);
        
        this.state = {
            already_downloaded: props.already_downloaded,
            modalIsOpen: false,
            formStatus: 'form-pending',
            formFulfilled: false,
            theYear: 0
        };
        this.captcha =  {};
        this.openModal = this.openModal.bind(this);
        this.afterOpenModal = this.afterOpenModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.submitAction = this.submitAction.bind(this);
        this.downloadAgain = this.downloadAgain.bind(this);
    }

    componentDidMount(){
        this.getSurveyYear(); // extract the survey year from window.location
        this.setSurveyYear(); // set the state of theYear as the return of getSurveryYear()
    }

    openModal() {
        this.setState({modalIsOpen: true});
    }
    
    afterOpenModal() {
        // references are now sync'd and can be accessed.
        this.subtitle.style.color = '#f00';
    }
    
    closeModal() {
        this.setState({modalIsOpen: false}, () => {
            //If the person is closing the form after successful form submission, set the already downloaded to true 
            if(this.state.formStatus === 'form-fulfilled'){
                this.setState({already_downloaded: true});
            }
        });
    }
    async submitAction(workConfidenceFormFields,captcha){

        let surveyResponse = await sendSurveyForm(workConfidenceFormFields,captcha);

        if(surveyResponse.data.success){
            this.setState({formStatus: 'form-fulfilled'}, async () => {
                let getPDFDownload = await downloadPDF('work_confidence_survey_' + this.state.theYear);
            });
        }
    }

    async downloadAgain(){
        this.setState({formStatus: 'form-fulfilled', already_downloaded: false}, async () => {
            let getPDFDownload = await downloadPDF('work_confidence_survey_' + this.state.theYear);
        });
    }
    /**
     * @method - Gets the relevant year for this work confidence document from window.location.pathname.
     * @return integer - returns the year as an integer
     */
    getSurveyYear(){
        const currentPathName = window.location.pathname;
        const dividePathName = currentPathName.split('-');
        const year = (dividePathName[dividePathName.length-1]);
        return year;
    }
    /**
     * @method - Sets the state theYear as the numeric year that is returned from this.getSurveyYear().
     * 
     */
    setSurveyYear(){
        this.setState({theYear : this.getSurveyYear()});
    }
    
    render() {
    const modalStyles = {
        content : {
            top                   : '50%',
            left                  : '50%',
            right                 : 'auto',
            bottom                : 'auto',
            marginRight           : '-50%',
            transform             : 'translate(-50%, -50%)',
            width                 : '500px',
            maxWidth              : '80%',
            border                : 'solid 1px',
            overflow              : 'hidden'
        }
    };
        return (
            <div>
                <div>
                    <button 
                        className="conf-report btn btn-mid-orange ubuntu ttrans-n" onClick={this.openModal}>
                        <span>Click to download </span> 
                        <span> a printable summary of the</span> 
                        <span> key survey findings!</span></button> 
                </div>
            <div>
            <Modal
                isOpen={this.state.modalIsOpen}
                onRequestClose={this.closeModal}
                shouldCloseOnOverlayClick={false}
                style={modalStyles}
                contentLabel="Download Survey"
            >
            {(this.state.formStatus == 'form-pending' && !this.state.already_downloaded) ?
                <WorkConfidenceForm
                    closeButton={this.closeModal}
                    submitAction={this.submitAction}
                />
            : ''}
            {(this.state.formStatus == 'form-fulfilled' && !this.state.already_downloaded) ? 
                <WorkConfidenceThankYou  
                    closeButton={this.closeModal}
                />
            : ''}
            {(this.state.already_downloaded) ? 
                <WorkConfidenceAlreadyDownloaded
                    downloadAgain={this.downloadAgain}  
                    closeButton={this.closeModal}
                />
            : ''}
            </Modal>
            </div>
        </div>
        );
    }
}

export default WorkConfidenceButton; 